module.exports = __webpack_public_path__ + "img/Terraform-Sales-1.9a017d74.png";